export const isSPSize = () => {
  return !!(window?.innerWidth < 600)
}

export const isTabletSize = () => {
  return !!(window?.innerWidth >= 600 && window?.innerWidth < 960)
}

export const isPCSize = () => {
  return !!(window?.innerWidth >= 960)
}
